import type { GlobeMarker } from "@src/components/globe/Globe/Globe";

export const REGION_MARKERS: GlobeMarker[] = [
  { id: "us-west-1", lat: 37.37, lng: -121.92, label: "us-west-1" },
  { id: "us-east-1", lat: 39.04, lng: -77.49, label: "us-east-1" },
  { id: "eu-west-1", lat: 53.35, lng: -6.26, label: "eu-west-1" },
  { id: "eu-central-1", lat: 50.11, lng: 8.68, label: "eu-central-1" },
  { id: "ap-southeast-1", lat: 1.35, lng: 103.82, label: "ap-southeast-1" },
  { id: "ap-northeast-1", lat: 35.68, lng: 139.65, label: "ap-northeast-1" },
  { id: "ap-southeast-2", lat: -33.87, lng: 151.21, label: "ap-southeast-2" },
  { id: "sa-east-1", lat: -23.55, lng: -46.63, label: "sa-east-1" }
];
